@if (configuredText) {
    <div class="text-widget-content">
        <cerrix-editor-viewer [value]="configuredText"></cerrix-editor-viewer>
    </div>
}
